import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import Joyride, { Step } from 'react-joyride'

import useT from '@/i18n/useT'

import CenteredBox from '../components/CenteredBox'
import DaiLogo from '../components/DaiLogo'
import { useTour } from './useTour'

const TOUR_NAME = 'web_home_tour_v1'

const DAIHomeJoyRide: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const { t } = useT()
  const { run, handleJoyrideCallback } = useTour({
    tourName: TOUR_NAME,
  })

  const locale: Step['locale'] = {
    skip: t('common.skip'),
    close: t('common.next'),
    back: t('common.back'),
    last: t('common.done'),
  }

  const steps: Step[] = [
    {
      content: (
        <Stack>
          <CenteredBox>
            <DaiLogo />
          </CenteredBox>
          <Typography variant="h6" sx={{ marginBottom: 2 }}>
            {t('homeTour.welcomeTitle')}
          </Typography>
          <Typography>{t('homeTour.welcomeMessage')}</Typography>
        </Stack>
      ),
      locale,
      placement: 'center',
      target: 'body',
      showSkipButton: true,
    },
    {
      target: '#settings-dropdown',
      content: t('homeTour.settingsMessage'),
      locale,
      showSkipButton: true,
    },
    {
      target: '#tasks-nav',
      content: t('homeTour.taskMessage'),
      locale,
      showSkipButton: true,
    },
    {
      target: '#restocks-nav',
      content: t('homeTour.restockMessage'),
      locale,
      showSkipButton: true,
    },
  ]

  if (isMobile) {
    return null
  }

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      disableScrolling
      callback={handleJoyrideCallback}
      styles={{
        options: {
          zIndex: 9999, // Ensure Joyride elements are on top
          arrowColor: theme.palette.background.paper,
          backgroundColor: theme.palette.background.paper,
          primaryColor: theme.palette.primary.main,
          textColor: theme.palette.text.primary,
        },
      }}
    />
  )
}

export default DAIHomeJoyRide
